import Vue from 'vue'

export default {
  namespaced: true,
  state: () => ({
    list: []
  }),
  getters: {
    list: state => state.list,
    map: state => state.list.reduce((map, factorGroup) => {
      map[factorGroup.id] = factorGroup
      return map
    }, {})
  },
  mutations: {
    list (state, list) {
      state.list = Object.freeze(list)
    }
  },
  actions: {
    request ({commit}) {
      return Vue.prototype.$api.FactorGroup.getList().then(factorGroups => {
        commit('list', factorGroups)
      }).catch(console.error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/FactorGroup.js